import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddMinSffixDirective } from './add-min-sffix.directive';
import { OnlyNumbersDirective } from './only-numbers-input.directive';
import { PercentagePromoDirective } from './percentage-promo.directive';
import { TitleCaseVisualDirective } from './title-case-visual.directive';

@NgModule({
	declarations: [
        AddMinSffixDirective,
		PercentagePromoDirective, 
		OnlyNumbersDirective,
		TitleCaseVisualDirective
	],
    imports: [
        CommonModule
    ],
	exports: [
		AddMinSffixDirective,
		PercentagePromoDirective,
		OnlyNumbersDirective,
		TitleCaseVisualDirective
	],
})
export class DirectiveModule {}